const participant = {
  username: null,
  id: null,
  home_phone: null,
  business_phone: null,
  business_name: null,
  first_name: '',
  created_at: null,
  home_zip_code: null,
  home_state: null,
  home_address1: null,
  home_address2: null,
  home_city: null,
  shipping_city: null,
  mobile_phone: null,
  last_name: '',
  job_title: null,
  preferred_first_name: null,
  phone_number: null,
  other_email: null,
  platform_id: null,
  preferred_last_name: null,
  primary_email: null,
  secondary_email: null,
  shipping_first_name: null,
  shipping_last_name: null,
  shipping_address1: null,
  shipping_address2: null,
  shipping_state: null,
  shipping_zip_code: null,
  shipping_email: null,
  shipping_phone: null,
  status: null,
  updated_at: null,
  catalog_is_enabled: null
}

export default participant



// WEBPACK FOOTER //
// ./src/store/entities/participant.js